import React, { Component } from "react";
import { withRouter } from "react-router-dom";

import Header from "../../common/header";
import Footer from "../../common/footer";
import Sidebar from "../../common/sidebar";

class UnAuthUser extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      tab: 0,
    };

    this.gotoLogin = this.gotoLogin.bind(this);
  }

  componentDidMount() {}

  gotoLogin = () => {
    // this.setState({userLoggedIn: false});
    localStorage.clear();
     localStorage.removeItem("userinfo");
this.props.history.push("/login");
  };

  render() {
    return (
      <div className="wrapper">
        <Header />

        <div className="content-wrapper pb-4">
          <section class="content">
            <div class="col-md-12">
              <h5>
                Sorry, unauthorized access to information has been denied.{" "}
                <a href="javascript:void(0);" onClick={this.gotoLogin}>
                  Login
                </a>
              </h5>
            </div>
          </section>
        </div>
        <Footer />
        <aside className="control-sidebar control-sidebar-dark"></aside>
      </div>
    );
  }
}
export default withRouter(UnAuthUser);
